import { render } from "./BoardItem.vue?vue&type=template&id=66cc2af4&scoped=true&ts=true"
import script from "./BoardItem.vue?vue&type=script&lang=ts"
export * from "./BoardItem.vue?vue&type=script&lang=ts"

import "./BoardItem.vue?vue&type=style&index=0&id=66cc2af4&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cc2af4"]])

export default __exports__